import React from 'react';
import _ from 'lodash';
import { NavLink } from 'fluxible-router';
import CategoryCardLink from './CategoryCardLink';

const CategoryCard = (props) => {
  const { category, articleCount } = props;

  const articles = _.take(category.articles, articleCount);
  const links = articles.map(article => (
    <li key={article.url} className="category-card-link">
      <CategoryCardLink article={article}>{article.title}</CategoryCardLink>
    </li>
  ));

  return (
    <div className="category-card-container col-sm-6 col-md-4">
      <div className="category-card">
        <div className="category-card-header">
          <i className={`${category.icon} ${category.color}`} />
          <NavLink className="category-card-name" href={category.url}>{category.title}</NavLink>
        </div>
        <div className="category-card-description">{category.description}</div>
        <ul className="category-card-links">
          {links}
        </ul>
        <NavLink className="category-card-more-link" href={category.url}>More</NavLink>
      </div>
    </div>
  );
};

CategoryCard.defaultProps = {
  articleCount: 3
};

export default CategoryCard;
